module.exports = __webpack_public_path__ + "img/storeBg.21995ef2.png";